import { ContainerModule, interfaces } from 'inversify';
import { ExportProjectStatsBl, IExportProjectStatsBl } from './export/ExportProjectStats.bl';
import { ExportProjectStatsService, IExportProjectStatsService } from './export/ExportProjectStats.service';
import { IProjectStatsFiltersBl, ProjectStatsFiltersBl } from './filters/ProjectStatsFilters.bl';
import { IProjectStatsFiltersStore, ProjectStatsFiltersStore } from './filters/ProjectStatsFilters.store';
import { IProjectStatsBl, ProjectStatsBl } from './ProjectStats.bl';
import { IProjectStatsStore, ProjectStatsStore } from './ProjectStats.store';
import { GetProjectStatsService, IGetProjectStatsService } from './services/GetProjectStats.service';

export const projectStatisticsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IProjectStatsStore.$).to(ProjectStatsStore).inSingletonScope();
  bind(IGetProjectStatsService.$).to(GetProjectStatsService).inRequestScope();
  bind(IProjectStatsBl.$).to(ProjectStatsBl).inRequestScope();
  bind(IProjectStatsFiltersBl.$).to(ProjectStatsFiltersBl).inRequestScope();
  bind(IProjectStatsFiltersStore.$).to(ProjectStatsFiltersStore).inSingletonScope();
  bind(IExportProjectStatsService.$).to(ExportProjectStatsService).inRequestScope();
  bind(IExportProjectStatsBl.$).to(ExportProjectStatsBl).inRequestScope();
});
